import React, { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, BrowserRouterProps, Routes } from 'react-router-dom';
import { ProfileProvider } from '../contexts/ProfileProvider.tsx';
import { UIProvider } from '../contexts/UIProvider.tsx';
import { IThemeContext } from '../contexts/types.ts';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export function RootTemplate({
  children,
  browserRouterProps = {},
  themeResolver,
}: {
  browserRouterProps?: BrowserRouterProps;
  themeResolver: () => Promise<Partial<IThemeContext>>;
} & PropsWithChildren) {
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <ProfileProvider>
          <UIProvider themeResolver={themeResolver}>
            <BrowserRouter {...browserRouterProps}>
              <Routes>{children}</Routes>
            </BrowserRouter>
          </UIProvider>
        </ProfileProvider>
      </QueryClientProvider>
    </React.Fragment>
  );
}
